import request from "@/utils/request";

//查询轮播表
export const listBanner = (query) =>{
    return request({
        url: "/authservice/yg/banner/listBanner",
        method:"get",
        params: query
    })
}
//新职咨询
export const listNews = (query) =>{
    return request({
        url: "/authservice/yg/news/listRelease",
        method:"get",
        params: query
    })
}
//课题列表
export const listTopic = (query) =>{
    return request({
        url: "/authservice/yg/lead/listTopic",
        method:"get",
        params: query
    })
}

//名师工作室列表
export const listTeacherGroup = (query) =>{
    return request({
        url: "/authservice/yg/group/listTeacherGroup",
        method:"get",
        params: query
    })
}

//名校长工作室列表
export const listHeadmasterGroup = (query) =>{
    return request({
        url: "/authservice/yg/group/listHeadmasterGroup",
        method:"get",
        params: query
    })
}

//高水平示范课
export const listHighCourse = (query) =>{
    return request({
        url: "/authservice/yg/course/listHighLevelCourse",
        method:"get",
        params: query
    })
}

//成果
export const listAchieve = (query) =>{
    return request({
        url: "/authservice/yg/achieve/listRelease",
        method:"get",
        params: query
    })
}

//工作室活跃度
export const listGroupActive = (query) =>{
    return request({
        url: "/authservice/yg/group/listGroupActive",
        method:"get",
        params: query
    })
}

//查询工作室动态-教师文章
export const listGroupTrends = (query) =>{
    return request({
        url: "/authservice/yg/group/listGroupTrends",
        method:"get",
        params: query
    })
}

//教研赛事
export const listRace = (query) =>{
    return request({
        url: "/authservice/yg/race/listClassRace",
        method:"get",
        params: query
    })
}

//专题活动
export const listActivity = (query) =>{
    return request({
        url: "/authservice/yg//activity/listActivity",
        method:"get",
        params: query
    })
}